export const ISEE_SUBSCRIBE_FIRST_EXPERIMENT_PROPERTY = "experiment.isee_subscribe_first";

export enum UpgradeFirstExperimentVariant {
  UPGRADE_FIRST = "subscribe_first",
  COMPLETE_INFO_FIRST = "completeInfo_first",
}
